module.exports = __webpack_public_path__ + "static/media/history_3.326025a7.jpg";